import moment from 'moment-jalaali'
import ProfileApis from '@/services/apis/profile'

const profile = new ProfileApis()

export default {
  props: {
    activeSession: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      onDeleteLoading: false,
      moment,
    }
  },
  mounted() {

  },
  methods: {
    onDelete() {
      this.onDeleteLoading = true
      profile.deleteActiveSessions({ session_id: this.activeSession.id }).then(() => {
        this.$emit('delete', this.activeSession.id)
      }).catch(err => {
        console.log(err)
      })
        .finally(() => {
          this.onDeleteLoading = false
        })
    },
  },
}
